import { IResponsePinCheck, IResponseSms, IResponseUniquePhone, IResponseUser, IResponseUser2 } from '../entities/user';

/**
 * 유저 entity 변환 함수
 *
 * @export
 * @param {any} resData
 * @return {*}  {IUser}
 */
// eslint-disable-next-line
export function mapUser(resData: any): IResponseUser {
  console.log('mapUser 주소확인', resData);

  const ret: IResponseUser = {
    shopCode: resData.shopCode,
    id: resData.id,
    password: resData.password,
    phone: resData.phone,
    name: resData.name,
    passwordRetryCount: resData.passwordRetryCount,
    status: resData.status,
    status_desc: resData.status_desc,
    trx_address: resData.trx_address,
    balance: {
      address: resData.balance.address,
      coinBalance: resData.balance.coinBalance,
      coinKRW: resData.balance.coinKRW,
      tokenBalance: resData.balance.tokenBalance,
      tokenKRW: resData.balance.tokenKRW,
      tokenBuyCount: resData.balance.tokenBuyCount,
      tokenBuyCountKRW: resData.balance.tokenBuyCountKRW,
    },
    pin: resData.pin,
    errorCount: resData.errorCount,
    lastLoginTime: resData.lastLoginTime,
    isLocked: resData.isLocked,
  };

  return ret;
}

// eslint-disable-next-line
export function mapUser2(resData: any): IResponseUser2 {
  console.log('mapUser2 주소확인', resData);
  const ret: IResponseUser2 = {
    shopCode: resData.shopCode,
    id: resData.id,
    password: resData.password,
    phone: resData.phone,
    name: resData.name,
    passwordRetryCount: resData.passwordRetryCount,
    status: resData.status,
    status_desc: resData.status_desc,
    lastLoginTime: resData.lastLoginTime,
    balance: {
      SOLANA: {
        address: resData.balance.SOLANA.address,
        balance: resData.balance.SOLANA.balance,
        price: resData.balance.SOLANA.price,
        krw: resData.balance.SOLANA.krw,
        tokenBalance: resData.balance.SOLANA.tokenBalance,
        tokenPrice: resData.balance.SOLANA.tokenPrice,
        tokenKRW: resData.balance.SOLANA.tokenKRW,
        tokenBuyCount: resData.balance.SOLANA.tokenBuyCount,
        tokenBuyCountKRW: resData.balance.SOLANA.tokenBuyCountKRW,
      },
    },
    errorCount: resData.errorCount,
    pin: resData.pin,
  };

  return ret;
}

/**
 * sms entity 변환 함수
 *
 * @export
 * @param {any} resData
 * @return {*}  {ISms}
 */
// eslint-disable-next-line
export function mapSms(resData: any): IResponseSms {
  const ret: IResponseSms = {
    authNumber: resData.authNumber,
  };

  return ret;
}

/**
 * 사용자 전화번호 중복 체크 entity 변환 함수
 *
 * @export
 * @param {*} resData
 * @return {*}  {IResponseUniquePhone}
 */
// eslint-disable-next-line
export function mapUniqueNumber(resData: any): IResponseUniquePhone {
  const ret: IResponseUniquePhone = {
    isUnique: resData,
  };

  return ret;
}

/**
 * 사용자 인증번호 체크 entity 변환 함수
 *
 * @param resData
 * @returns
 */
// eslint-disable-next-line
export function mapPinCheck(resData: any): IResponsePinCheck {
  const ret: IResponsePinCheck = {
    success: textToBoolean(resData),
  };

  return ret;
}

/**
 * 문자열을 불리언으로 변환하는 함수
 *
 * @param {string} text
 * @return {*}  {boolean}
 */
function textToBoolean(text: string): boolean {
  if (text === 'isMatched') return true;
  if (text === 'isNotMatched') return false;

  return false;
}
